'use strict';

import SearchSwitchTriple from "../components/SearchSwitchTriple";

function SearchSwitchTripleWidget({
    type,
    onChangeType,
    planesCount,
    seatsCount,
    toursCount,
    useLocalStorageCounters,
}) {
    return (
        <SearchSwitchTriple
            type={type}
            onChangeType={onChangeType}
            planesCount={planesCount}
            seatsCount={seatsCount}
            toursCount={toursCount}
            useLocalStorageCounters={useLocalStorageCounters}
        />
    )
}

window.SearchSwitchTripleWidget = SearchSwitchTripleWidget;
